/**
 * Enumeration of Web Audio API biquad filter types used in intelligent photo capture shutter sound synthesis.
 */
export var IntelligentPhotoCaptureShutterSoundFilterType;
(function (IntelligentPhotoCaptureShutterSoundFilterType) {
    IntelligentPhotoCaptureShutterSoundFilterType["BANDPASS"] = "bandpass";
    IntelligentPhotoCaptureShutterSoundFilterType["HIGHPASS"] = "highpass";
})(IntelligentPhotoCaptureShutterSoundFilterType || (IntelligentPhotoCaptureShutterSoundFilterType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureShutterSoundFilterType.js.map